import { rem } from '@/theme'
import styled from 'styled-components'

const InterimRoutingStyle = styled.div`

	${({ theme }) => theme.align_center};
	background: ${({ theme }) => theme.con_bg};
	border: 1px solid ${({ theme }) => theme.gray100};
	div.text-module {
		position: relative;
	}

	// PC
	@media screen and (min-width: 540px) { 
		min-height: 300px;
		margin-top: 20px;
		padding: 25px 20px 5px 20px;
		border-radius: 24px;
		div.text-module {
			margin-top: 5px;
			left: -30px;
		}
	}

	// H5
	@media screen and (max-width: 540px) {
		min-height: ${rem(300)};
		margin-top: ${rem(16)};
		padding: ${rem(16)} ${rem(5)};
		border-radius: ${rem(16)};
		& > div {
			div.text-module {
				margin-top: ${rem(5)};
				left: ${rem(-25)};
			}
		}
	}
`

export {
	InterimRoutingStyle,
}